// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router';
// import { createRouter, createWebHistory } from 'vue-router';


const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/components/KakeiShienApp.vue'),
  },
  {
    path: '/share',
    name: 'Share',
    component: () => import('@/components/ShareResult.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
//   history: createWebHistory(),
  routes,
});

// Google Analytics ページ遷移追跡
router.afterEach((to) => {
  if (window.gtag && process.env.VUE_APP_GA_MEASUREMENT_ID) {
    window.gtag('config', process.env.VUE_APP_GA_MEASUREMENT_ID, {
      page_path: to.fullPath,
      page_title: to.meta?.title || document.title
    });
  }
});

export default router;
